module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAABHNCSVQICAgIfAhkiAAAAOpJREFUSIntVlsOgyAQHBqvYOQ425OJJ5PjtNlD0A+kRcpDMSRNyvy4GcfdAdkNwL9DuIAlCAYzAGpUS0NgGR/QPjm8o7bFAYBgNiMx8ATD0yZpgFT+W6uCR9ENdAOHDLCEYrlv0RiX48tFEm3CE9bwHUuQ41hC5bSl/Gd+gfZiSvA5Lo+kcwlKbDX5q89pc/mPCy6iT8Ju4GcNDF6sATtgsl/YW43yKZZQ24WmBB0Snx0QWGKCLxjMu+l3pritUQ+WUH4/ByOZLiU/bcI+3exfa/OJsiRiIjgn47MuD1DbBQJ3uPNi445qvADBTXsITYVM2QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img21.png
// module id = lS5f
// module chunks = 1